(() => {
  const container = document.getElementById('ProductGridContainer');
  if (!container || !container.dataset.wdltPageSize) return;
  const params = new URLSearchParams(location.search);
  const discountMode = params.get('wdlt_sort') === 'discount';
  const saleOnly=params.get('wdlt_sale')==='1';
  const standardMode = !discountMode && !saleOnly;
  const defaultSort = params.get('sort_by') || container.dataset.wdltDefaultSort || 'created-descending';
  const contextURL = value => {
    const url = new URL(value);
    ['page', 'wdlt_page', 'sections'].forEach(key => url.searchParams.delete(key));
    url.searchParams.sort();
    return url.pathname + url.search;
  };
  const initialContext = contextURL(location.href);
  if(saleOnly){
    document.querySelectorAll('.wdlt-mobile-controls>details:first-child>summary,.wdlt-filters-title').forEach(label=>{
      const match=label.textContent.match(/\((\d+)\)/);
      label.textContent=label.textContent.replace(/\s*\(\d+\)/,'')+' ('+(Number(match?.[1]||0)+1)+')';
    });
  }
  let records;
  let pending;
  let run = 0;
  const pageSize = Number(container.dataset.wdltPageSize) || 24;
  const sortURL = value => {
    const url = new URL(location.href);
    ['page', 'wdlt_page', 'wdlt_sort'].forEach(key => url.searchParams.delete(key));
    url.searchParams.set('sort_by', value === 'discount-descending' ? 'created-descending' : value);
    if (value === 'discount-descending') url.searchParams.set('wdlt_sort', 'discount');
    return url;
  };
  document.querySelectorAll('.wdlt-sort-options li').forEach(item => {
    const link = item.querySelector('a');
    link.href = sortURL(item.dataset.value);
    const active = discountMode ? 'discount-descending' : defaultSort;
    if (item.dataset.value === active) link.setAttribute('aria-current', 'true');
  });
  document.addEventListener('click', event => {
    const item = event.target.closest('.wdlt-sort-options li');
    if (!item) return;
    event.stopImmediatePropagation();
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const drawer = item.closest('.wdlt-sort-drawer');
    if (drawer?.open) drawer.close();
    location.assign(sortURL(item.dataset.value));
  }, true);
  function initStandardPagination() {
    const grid = container.querySelector('ul#product-grid');
    const initialCollection = container.querySelector('.collection');
    if (!grid || !initialCollection || !grid.dataset.id) return;
    const sectionId = grid.dataset.id;
    const cache = new Map();
    const pending = new Map();
    let navigation = 0;
    const status = document.createElement('div');
    status.className = 'wdlt-sort-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    container.prepend(status);
    function key(value) {
      const url = new URL(value, location.href);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      if (url.searchParams.get('page') === '1') url.searchParams.delete('page');
      url.hash = '';
      url.searchParams.sort();
      return url.href;
    }
    function remember(url, html) {
      cache.set(key(url), html);
      while (cache.size > 8) cache.delete(cache.keys().next().value);
    }
    remember(location.href, initialCollection.outerHTML);
    async function load(value) {
      const normalized = key(value);
      if (cache.has(normalized)) return cache.get(normalized);
      if (pending.has(normalized)) return pending.get(normalized);
      const request = (async () => {
        const url = new URL(normalized);
        url.searchParams.set('section_id', sectionId);
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Product page: HTTP ' + response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const collection = doc.querySelector('#ProductGridContainer .collection');
          if (!collection?.querySelector('ul#product-grid')) throw new Error('Product page unavailable');
          const html = collection.outerHTML;
          remember(normalized, html);
          return html;
        } finally {
          clearTimeout(timeout);
        }
      })();
      pending.set(normalized, request);
      try { return await request; } finally { pending.delete(normalized); }
    }
    function nextPage() {
      const links = [...container.querySelectorAll('.pagination a[href]')];
      const current = Number(new URL(location.href).searchParams.get('page')) || 1;
      return links.find(link => Number(new URL(link.href).searchParams.get('page')) === current + 1);
    }
    function prefetchNext() {
      const next = nextPage();
      if (next) load(next.href).catch(() => {});
    }
    async function navigate(value, push = true, scroll = true) {
      const url = new URL(value, location.href);
      const token = ++navigation;
      container.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.textContent = container.dataset.wdltLoading || 'Loading products…';
      try {
        const html = await load(url);
        if (token !== navigation) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        container.querySelector('.collection').replaceWith(doc.querySelector('.collection'));
        if (push) history.pushState({wdltCollectionPage: true}, '', url);
        status.hidden = true;
        status.textContent = '';
        if (scroll) container.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        prefetchNext();
      } catch (error) {
        if (token !== navigation) return;
        status.textContent = container.dataset.wdltError || 'Unable to load products.';
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = container.dataset.wdltRetry || 'Retry';
        retry.addEventListener('click', () => navigate(url, push, scroll));
        status.append(retry);
      } finally {
        if (token === navigation) container.removeAttribute('aria-busy');
      }
    }
    container.addEventListener('click', event => {
      const link = event.target.closest('.pagination a[href]');
      if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href);
      if (url.origin !== location.origin || contextURL(url) !== initialContext) return;
      event.preventDefault();
      navigate(url);
    });
    function prefetchLink(event) {
      const link = event.target.closest('.pagination a[href]');
      if (!link) return;
      const url = new URL(link.href);
      if (url.origin === location.origin && contextURL(url) === initialContext) load(url).catch(() => {});
    }
    container.addEventListener('pointerover', prefetchLink);
    container.addEventListener('focusin', prefetchLink);
    window.addEventListener('popstate', event => {
      if (contextURL(location.href) !== initialContext) { location.reload(); return; }
      event.stopImmediatePropagation();
      navigate(location.href, false, false);
    }, true);
    if ('requestIdleCallback' in window) requestIdleCallback(prefetchNext, {timeout: 1500});
    else setTimeout(prefetchNext, 500);
  }
  if (standardMode) { initStandardPagination(); return; }

  const status = document.createElement('div');
  status.className = 'wdlt-sort-status';
  status.setAttribute('role', 'status');
  container.prepend(status);
  const feedURL = page => {
    const url = new URL(location.href);
    ['wdlt_sort', 'wdlt_page', 'page', 'sections'].forEach(key => url.searchParams.delete(key));
    url.searchParams.set('sort_by', discountMode ? 'created-descending' : defaultSort);
    url.searchParams.set('section_id', 'wdlt-discount-products');
    url.searchParams.set('page', String(page));
    return url;
  };
  const loadedPages = new Map();
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
  async function fetchPage(page) {
    if (loadedPages.has(page)) return loadedPages.get(page);
    let lastError;
    for (let attempt = 0; attempt < 3; attempt++) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch(feedURL(page), {signal: controller.signal, cache: attempt ? 'reload' : 'default'});
        if (!response.ok) throw new Error('Product page ' + page + ': HTTP ' + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = doc.querySelector('[data-wdlt-discount-feed]');
        const end = feed?.querySelector('[data-wdlt-page-end]');
        if (!feed || !end || Number(feed.dataset.page) !== page) throw new Error('Incomplete product page ' + page);
        const templates = Array.from(feed.querySelectorAll('template[data-product-id]'));
        const expected = Number(end.dataset.renderedCount);
        const pages = Number(feed.dataset.pages);
        const count = Number(feed.dataset.count);
        if (!Number.isInteger(expected) || expected < 0 || templates.length !== expected || !Number.isInteger(pages) || pages < 0 || pages > 100 || !Number.isInteger(count) || count < 0 || count > 25000) throw new Error('Invalid product page ' + page);
        const items = templates.map(template => {
          const price = Number(template.dataset.price);
          const compare = Number(template.dataset.compare);
          const created = Number(template.dataset.created);
          const card = template.content.querySelector('li.grid__item');
          if (!template.dataset.productId || !card || !Number.isFinite(price) || !Number.isFinite(compare) || !Number.isFinite(created)) throw new Error('Invalid product card on page ' + page);
          return {id: template.dataset.productId, available: !card.classList.contains('sold_out'), discount: compare > price && compare > 0 ? (compare-price)/compare : 0, created, template};
        });
        const result = {pages, count, items};
        loadedPages.set(page, result);
        return result;
      } catch (error) {
        lastError = error;
      } finally {
        clearTimeout(timeout);
      }
      if (attempt < 2) await pause(500 * (attempt + 1));
    }
    throw lastError;
  }
  async function loadAll() {
    const first = await fetchPage(1);
    const pages = [first];
    for (let page = 2; page <= first.pages; page += 3) {
      const batch = [];
      for (let next = page; next < page+3 && next <= first.pages; next++) batch.push(fetchPage(next));
      pages.push(...await Promise.all(batch));
    }
    // Validate each rendered page; Shopify's reported total can differ from its loop output.
    const unique = new Map();
    pages.forEach(page => page.items.forEach(item => { if (!unique.has(item.id)) unique.set(item.id, item); }));
    const all = Array.from(unique.values());
    if (all.length !== first.count) console.info('[WDLT sorting] Reported total:', first.count, 'rendered products:', all.length);
    container.dataset.wdltLoadedCount = String(all.length);
    return all.filter(item=>!saleOnly || item.discount>0).sort((a,b) => discountMode ? b.discount-a.discount || b.created-a.created || a.id.localeCompare(b.id) : 0);
  }
  function pageURL(page) {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('wdlt_page');
    url.searchParams.set(standardMode ? 'page' : 'wdlt_page', String(page));
    return url;
  }
  function pagination(page, pages) {
    container.querySelectorAll('.pagination-wrapper').forEach(node => node.remove());
    if (pages < 2) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'pagination-wrapper wdlt-discount-pagination';
    const nav = document.createElement('nav');
    nav.className = 'pagination';
    nav.setAttribute('aria-label', 'Pagination');
    const list = document.createElement('ul');
    list.className = 'pagination__list list-unstyled';
    function add(label, number) {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'pagination__item link';
      link.textContent = label;
      link.href = pageURL(number);
      link.dataset.wdltPage = number;
      if (page === number) { link.setAttribute('aria-current','page'); link.classList.add('pagination__item--current'); }
      li.append(link); list.append(li);
    }
    if (page > 1) add(container.dataset.wdltPrevious,page-1);
    const numbers = [...new Set([1, page-1, page, page+1, pages])].filter(n => n >= 1 && n <= pages).sort((a,b)=>a-b);
    numbers.forEach((number,index) => {
      if (index && number > numbers[index-1]+1) {
        const li = document.createElement('li');
        const gap = document.createElement('span');
        gap.textContent='…'; gap.className='pagination__item';
        li.append(gap); list.append(li);
      }
      add(String(number),number);
    });
    if (page < pages) add(container.dataset.wdltNext,page+1);
    nav.append(list); wrapper.append(nav);
    container.querySelector('.collection').append(wrapper);
  }
  async function render(scroll = false) {
    const token = ++run;
    container.setAttribute('aria-busy','true');
    status.hidden=standardMode; status.textContent=standardMode ? '' : container.dataset.wdltLoading;
    try {
      if (!records) {
        if (!pending) pending = loadAll().catch(error => { pending=null; throw error; });
        records = await pending;
      }
      if (token !== run) return;
      const pages = Math.max(1,Math.ceil(records.length/pageSize));
      const currentParams = new URLSearchParams(location.search);
      const requested = Number(currentParams.get('wdlt_page') || currentParams.get('page')) || 1;
      const page = Math.min(pages,Math.max(1,Math.floor(requested)));
      const grid = container.querySelector('ul#product-grid');
      if (records.length && !grid) throw new Error('Product grid unavailable');
      if (grid) {
        const existing = new Map();
        if (standardMode) Array.from(grid.children).forEach(card => {
          const href = card.querySelector('h3 a')?.getAttribute('href');
          if (href) existing.set(href, card);
        });
        const fragment=document.createDocumentFragment();
        records.slice((page-1)*pageSize,page*pageSize).forEach(record => {
          const href = record.template.content.querySelector('h3 a')?.getAttribute('href');
          const card = standardMode && existing.get(href);
          fragment.append(card || record.template.content.cloneNode(true));
        });
        grid.replaceChildren(fragment);
        pagination(page,pages);
      }
      if(saleOnly){
        let count=container.querySelector('.wdlt-product-count');
        if(!count){count=document.createElement('p');count.className='wdlt-product-count';count.setAttribute('role','status');status.after(count);}
        if(count){count.textContent=records.length+' products';count.hidden=false;count.style.display='block';}
        status.textContent=records.length ? '' : 'No sale products match these filters.';
      }
      status.hidden=!saleOnly || records.length>0;
      container.removeAttribute('aria-busy');
      if (scroll) container.scrollIntoView({block:'start',behavior:'smooth'});
    } catch (error) {
      if (token !== run) return;
      console.warn('[WDLT sorting] Loading failed:', error);
      status.hidden=false;
      status.textContent=container.dataset.wdltError;
      const retry=document.createElement('button');
      retry.type='button'; retry.textContent=container.dataset.wdltRetry;
      retry.addEventListener('click',()=>render()); status.append(retry);
    } finally {
      if (token === run) container.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click',event => {
    const link=event.target.closest('[data-wdlt-page]');
    if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    history.pushState({wdltDiscount:!standardMode,wdltCollectionPage:true},'',link.href);
    render(true);
  });
  window.addEventListener('popstate', event => {
    if (contextURL(location.href) !== initialContext) { location.reload(); return; }
    event.stopImmediatePropagation();
    render();
  },true);
  render();
})();


// Mobile sorting shares the Filters drawer presentation.
(() => {
  const control = document.querySelector('.wdlt-mobile-controls > details:last-child');
  const filterDrawer = document.getElementById('WdltFilterDrawer');
  if (!control || !filterDrawer) return;
  const trigger = control.querySelector('summary');
  const source = control.querySelector('.wdlt-sort-options');
  if (!trigger || !source) return;
  const mobile = matchMedia('(max-width: 989px)');
  const drawer = document.createElement('dialog');
  drawer.id = 'WdltSortDrawer';
  drawer.className = 'wdlt-filter-drawer wdlt-sort-drawer';
  drawer.setAttribute('aria-labelledby', 'WdltSortDrawerTitle');
  const header = filterDrawer.querySelector('.wdlt-drawer-header').cloneNode(true);
  const title = header.querySelector('h2');
  title.id = 'WdltSortDrawerTitle';
  title.textContent = 'Sort By';
  const close = header.querySelector('button');
  close.setAttribute('aria-label', 'Close sort options');
  close.removeAttribute('data-drawer-close');
  const body = document.createElement('div');
  body.className = 'wdlt-drawer-scroll';
  body.append(source.cloneNode(true));
  drawer.append(header, body);
  document.body.append(drawer);
  const style = document.createElement('style');
  style.textContent = `@media(max-width:989px){
    html.wdlt-sort-lock,html.wdlt-sort-lock body{overflow:hidden!important}
    dialog.wdlt-filter-drawer.wdlt-sort-drawer{inset:0 0 0 auto}
    dialog.wdlt-filter-drawer.wdlt-sort-drawer[open]{animation:wdlt-sort-enter .22s ease-out}
    .wdlt-sort-drawer .wdlt-sort-options{position:static!important;display:block!important;width:100%!important;margin:0!important;padding:0!important;list-style:none;text-align:left;font:inherit}
    .wdlt-sort-drawer .wdlt-sort-options li{display:block;padding:0;margin:0;border-bottom:.5px solid #d7d7d7;font:inherit}
    .wdlt-sort-drawer .wdlt-sort-options a{display:flex;align-items:center;justify-content:space-between;min-height:48px;padding:10px 0;box-sizing:border-box;font:inherit;color:inherit;text-decoration:none}
    .wdlt-sort-drawer .wdlt-sort-options a[aria-current="true"]::after{content:"";width:5px;height:10px;border-right:1px solid currentColor;border-bottom:1px solid currentColor;transform:rotate(45deg);margin-right:4px}
    #WdltSortDrawerTitle:focus{outline:none}
    @keyframes wdlt-sort-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}
    @media(prefers-reduced-motion:reduce){dialog.wdlt-filter-drawer.wdlt-sort-drawer[open]{animation:none}}
  }`;
  document.head.append(style);
  const dismiss = () => { if (drawer.open) drawer.close(); };
  trigger.addEventListener('click', event => {
    if (!mobile.matches) return;
    event.preventDefault();
    control.open = false;
    drawer.showModal();
    document.documentElement.classList.add('wdlt-sort-lock');
    trigger.setAttribute('aria-expanded', 'true');
    title.focus();
  });
  close.addEventListener('click', dismiss);
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('wdlt-sort-lock');
    trigger.setAttribute('aria-expanded', 'false');
    if (mobile.matches) trigger.focus();
  });
  const sync = () => {
    if (mobile.matches) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', drawer.id);
      trigger.setAttribute('aria-expanded', String(drawer.open));
    } else {
      dismiss();
      ['aria-haspopup','aria-controls','aria-expanded'].forEach(name => trigger.removeAttribute(name));
    }
  };
  mobile.addEventListener('change', sync);
  sync();
})();

